/**
 * @desc 入库单导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
